import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { TdAjax } from 'app/lib/tdAjax';

import {
  EDIT_PAYER,
  editSuccess,
  editFailure,
  RESTORE_CONFIG_VERSION,
  restoreSuccess,
  restoreFailure
} from './actions';

const editPayerEpic = action$ =>
  action$.pipe(
    ofType(EDIT_PAYER),
    mergeMap(action =>
      TdAjax.put(`/payers/${action.payload.payer_id}/update_config`, action.payload).pipe(
        map(response => {
          location.href = `/payers/${action.payload.payer_id}`;
          return editSuccess(response);
        }),
        catchError(error => of(editFailure(error))))
    ));

const restorePayerVersionEpic = action$ =>
  action$.pipe(
    ofType(RESTORE_CONFIG_VERSION),
    mergeMap(action =>
      TdAjax.put(`/payers/${action.payload.payer_id}/active_version`, action.payload).pipe(
        map(response => {
          location.href = `/payers/${action.payload.payer_id}`;
          return restoreSuccess(response);
        }),
        catchError(error => of(restoreFailure(error))))
      ));

export {
  editPayerEpic,
  restorePayerVersionEpic
};

export default combineEpics(editPayerEpic, restorePayerVersionEpic);
